import { Formatter } from '@stamhoofd/utility';
import { PaymentType, PaymentTypeHelper } from './PaymentType.js';
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Unknown"] = "Unknown";
    PaymentMethod["PointOfSale"] = "PointOfSale";
    PaymentMethod["Transfer"] = "Transfer";
    PaymentMethod["DirectDebit"] = "DirectDebit";
    PaymentMethod["Bancontact"] = "Bancontact";
    PaymentMethod["iDEAL"] = "iDEAL";
    PaymentMethod["Payconiq"] = "Payconiq";
    PaymentMethod["CreditCard"] = "CreditCard";
    /**
     * A wallet to wallet transfer
     */
    PaymentMethod["AccountDeductions"] = "AccountDeducations";
})(PaymentMethod || (PaymentMethod = {}));
/**
 * Money that was paid via one of these methods never passes through a payment provider, so it is
 * received on the bank account right away instead of being paid out afterwards.
 */
export const OFFLINE_PAYMENT_METHODS = [
    PaymentMethod.Transfer,
    PaymentMethod.PointOfSale,
    PaymentMethod.Unknown,
    // Moving money between two balances doesn't bring anything in
    PaymentMethod.AccountDeductions,
];
export var PaymentMethodV150;
(function (PaymentMethodV150) {
    PaymentMethodV150["Unknown"] = "Unknown";
    PaymentMethodV150["Transfer"] = "Transfer";
    PaymentMethodV150["DirectDebit"] = "DirectDebit";
    PaymentMethodV150["Bancontact"] = "Bancontact";
    PaymentMethodV150["iDEAL"] = "iDEAL";
    PaymentMethodV150["Payconiq"] = "Payconiq";
    PaymentMethodV150["CreditCard"] = "CreditCard";
})(PaymentMethodV150 || (PaymentMethodV150 = {}));
export function downgradePaymentMethodV150(newerValue) {
    if (newerValue === PaymentMethod.PointOfSale) {
        return PaymentMethodV150.Transfer;
    }
    return newerValue;
}
export function downgradePaymentMethodArrayV150(newerValue) {
    return newerValue.map(v => downgradePaymentMethodV150(v));
}
export class PaymentMethodHelper {
    static getName(method, context = null) {
        switch (method) {
            case PaymentMethod.Unknown: return $t(`%mc`);
            case PaymentMethod.PointOfSale: {
                switch (context) {
                    case 'takeout': return $t(`%md`);
                    case 'delivery': return $t(`%me`);
                    case 'Takeout': return $t(`%md`);
                    case 'Delivery': return $t(`%me`);
                    case 'OnSite': return $t(`%mf`);
                    default: return $t(`%mf`);
                }
            }
            case PaymentMethod.Transfer: return $t(`%mg`);
            case PaymentMethod.DirectDebit: return $t(`%mh`);
            case PaymentMethod.Bancontact: return $t(`%1S`);
            case PaymentMethod.iDEAL: return $t(`%1n`);
            case PaymentMethod.CreditCard: return $t(`%mi`);
            case PaymentMethod.Payconiq: return $t(`%1cA`);
            case PaymentMethod.AccountDeductions: return $t(`%1cq`);
        }
    }
    static getPaymentName(method, type) {
        if (type === PaymentType.Payment) {
            switch (method) {
                case PaymentMethod.Unknown: return $t(`%mj`);
                case PaymentMethod.PointOfSale: {
                    return $t(`%mk`);
                }
                case PaymentMethod.Transfer: return $t(`%mg`);
                case PaymentMethod.DirectDebit: return $t(`%mh`);
                case PaymentMethod.Bancontact: return $t(`%ml`);
                case PaymentMethod.iDEAL: return $t(`%mm`);
                case PaymentMethod.CreditCard: return $t(`%mn`);
                case PaymentMethod.Payconiq: return $t(`%1VE`);
                case PaymentMethod.AccountDeductions: return $t(`%1cq`);
            }
        }
        if (type === PaymentType.Refund) {
            return $t(`%mp`) + ' ' + PaymentMethodHelper.getName(method);
        }
        if (type === PaymentType.Chargeback) {
            return $t(`%mq`) + ' ' + PaymentMethodHelper.getName(method);
        }
        return PaymentTypeHelper.getName(type);
    }
    static getPluralName(method) {
        switch (method) {
            case PaymentMethod.Unknown: return $t(`%mr`);
            case PaymentMethod.PointOfSale: {
                return $t(`%ms`);
            }
            case PaymentMethod.Transfer: return $t(`%lK`);
            case PaymentMethod.DirectDebit: return $t(`%mt`);
            case PaymentMethod.Bancontact: return $t(`%1S`);
            case PaymentMethod.iDEAL: return $t(`%1n`);
            case PaymentMethod.CreditCard: return $t(`%mi`);
            case PaymentMethod.Payconiq: return $t(`%1P4`);
            case PaymentMethod.AccountDeductions: return $t(`%1Ym`);
        }
    }
    static getNameCapitalized(method, context = null) {
        if (method === PaymentMethod.iDEAL) {
            return PaymentMethodHelper.getName(method, context);
        }
        return Formatter.capitalizeFirstLetter(PaymentMethodHelper.getName(method, context));
    }
    static getPluralNameCapitalized(method) {
        if (method === PaymentMethod.iDEAL) {
            return PaymentMethodHelper.getPluralName(method);
        }
        return Formatter.capitalizeFirstLetter(PaymentMethodHelper.getPluralName(method));
    }
    static canCreateMandate(method) {
        return method === PaymentMethod.Bancontact || method === PaymentMethod.CreditCard || method === PaymentMethod.iDEAL;
    }
    static isOnline(method) {
        return !OFFLINE_PAYMENT_METHODS.includes(method);
    }
}
//# sourceMappingURL=PaymentMethod.js.map